module.exports = __webpack_public_path__ + "img/stock7.bc210919.png";